import { EditContext } from "../contexts/EditContext";
import { GroupContext } from "../contexts/GroupContext";
import { SelectionContext } from "../contexts/SelectionContext";
import { SetContext } from "../contexts/SetContext";
import { SingletonContext } from "../contexts/SingletonContext";
import { ToolbarContext } from "../contexts/ToolbarContext";
import { is_navigation_context } from "../contexts/NavigationContext";
import { ContextManager } from "../../lib/context";
import { Switchboard } from "../../lib/events";
export class GSAContextManager extends ContextManager {
    constructor(map, p_layer, m_layer, b_layer) {
        super();
        this.navigation_receiver = Switchboard.get_receiver("NAVIGATION");
        this.add_contexts(new SingletonContext(map, p_layer, b_layer), new SetContext(map, p_layer), new SelectionContext(map, p_layer, m_layer), new GroupContext(map, p_layer, 'group'), new GroupContext(map, p_layer, 'nh'), new GroupContext(map, p_layer, 'sale'), new GroupContext(map, p_layer, 'land'), new ToolbarContext(map), new EditContext(map, p_layer, m_layer));
        this.navigation_receiver.on('navigate', (f) => {
            this.context.map((c) => {
                if (is_navigation_context(c))
                    c.navigate(f);
            });
        });
    }
}
